import { TContactInitialState } from '../types';

export const updateContactState = (
    state: TContactInitialState,
    payload: Partial<TContactInitialState>
): TContactInitialState => ({
    ...state,
    ...payload,
});
